import React, { useEffect, useState } from "react";
import { Download, X, Smartphone } from "lucide-react";

const DISMISS_KEY = "bitego_install_dismissed";

// Premium install card for the Login page. Renders nothing unless the browser
// actually offered installation (beforeinstallprompt) and the user hasn't
// dismissed it or already installed the app. Triggers the browser's native flow.
export function InstallCard() {
  const [evt, setEvt] = useState(() => (typeof window !== "undefined" ? window.__bipEvent : null));
  const [hidden, setHidden] = useState(() => localStorage.getItem(DISMISS_KEY) === "1");

  useEffect(() => {
    const onReady = () => setEvt(window.__bipEvent || null);
    const onInstalled = () => { setEvt(null); setHidden(true); };
    window.addEventListener("bip-ready", onReady);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("bip-ready", onReady);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const standalone = typeof window !== "undefined" && ((window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) || window.navigator.standalone);
  if (hidden || standalone || !evt) return null;

  const install = async () => {
    try {
      evt.prompt();
      await evt.userChoice;
    } catch (e) { /* ignore */ }
    window.__bipEvent = null;
    setEvt(null);
  };
  const dismiss = () => { localStorage.setItem(DISMISS_KEY, "1"); setHidden(true); };

  return (
    <div className="mt-4 bg-white border border-border rounded-2xl shadow-sm p-4 sm:p-5" data-testid="install-card">
      <div className="flex items-start gap-3.5">
        <div className="relative shrink-0">
          <img src="/bitego-icon.png" alt="BiteGoFood" className="w-12 h-12 rounded-2xl" />
          <span className="absolute -bottom-1 -right-1 w-6 h-6 rounded-full bg-coral text-white flex items-center justify-center ring-2 ring-white"><Smartphone size={13} /></span>
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-display font-bold text-[15px] text-ink leading-tight">Get the BiteGoFood App</h3>
          <p className="text-xs text-ink-600 mt-1 leading-relaxed">Install BiteGoFood for faster access and a smoother ordering experience.</p>
        </div>
        <button onClick={dismiss} className="text-ink-600/70 hover:text-ink transition-colors tap shrink-0 -mt-1 -mr-1 p-1" aria-label="Dismiss" data-testid="install-card-dismiss"><X size={16} /></button>
      </div>
      <button onClick={install} className="mt-3.5 w-full bg-coral hover:bg-coral-hover active:scale-[0.99] text-white font-bold py-3 rounded-xl flex items-center justify-center gap-2 transition-all shadow-sm shadow-coral/30 tap" data-testid="install-card-btn">
        <Download size={17} /> Install BiteGoFood
      </button>
    </div>
  );
}
